export default __webpack_public_path__ + "static/kanvas-collaborate-cc24b668ffb445bd748c0023f4dfa5fd.webp";